<template>
  <div class="container">
    <el-container>
      <el-header height="59">
        <projectHeader @dialogTableVisible="dialogVisible = true"></projectHeader>
      </el-header>
      <el-main>
          <projectDetails></projectDetails>
          <div class="main-center">
            <div class="total-progress" v-if="centerProgress.centerProgressSizeDto">
              <p class="total-title">{{$t('top.common.recruitingProcess')}}:</p>
              <span class="total-text total-number">{{centerProgress.centerProgressSizeDto.patientNumber}}</span>
              <span class="total-text total-percent">{{centerProgress.centerProgressSizeDto.progressPercentage}}</span>
              <el-progress
                color="#1890FF"
                style="flex:0.73"
                :percentage="strConvert(centerProgress.centerProgressSizeDto.progressPercentage)"
                :stroke-width="11"
                :show-text="false"
              >
              </el-progress>
            </div>
            <mapData class="wrap-shadow" :projectCenterList="projectCenterList"></mapData>
            <caseData
              class="wrap-shadow"
              :actived="actived"
              :activedDate="activedDate"
              @queryCaseType="queryCaseType"
              @queryDate="queryDate"
              @selectedDate="selectedDate"
              :lineChartData="lineChartData"
            >
            </caseData>
          </div>
          <projectProcess class="wrap-shadow" :centerProgress="centerProgress"></projectProcess>
      </el-main>
      <projectFooter></projectFooter>
      <el-dialog :visible.sync="dialogVisible">
        <img
          src="../../assets/image/Introduction.png"
          alt=""
          class="dialog-image"
        />
      </el-dialog>
    </el-container>
  </div>
</template>

<script>
import projectHeader from "./components/projectHeader";
import projectFooter from "./components/projectFooter";
import projectDetails from "./components/projectDetails";
import projectProcess from "./components/projectProcess";
import mapData from "./components/mapData";
import caseData from "./components/caseData";
export default {
  name: "dataCharts",
  components: {
    projectHeader,
    projectFooter,
    projectDetails,
    projectProcess,
    mapData,
    caseData,
  },
  data() {
    return {
      actived: 0,
      activedDate: 0,
      projectCenterList: [],
      centerProgress: {centerProgressSizeDto:{}, centerProgressSizeDtoList:[]},
      lineChartData: [],
      projectId: "7b6dc230d8b04bd197f1ce64abb907ad",//生产
      // projectId: "8e711830f07749d2bdc8ffb4daf3e11c",// 测试
      startDate: "",
      endDate: "",
      type: 0,
      dialogVisible: false,
    };
  },
  created() {
    this.getDate(this.activedDate);
    this.getProjectCenterList();
    this.getCenterPatientSize();
    this.getCaseStatistics();
  },
  methods: {
    async getProjectCenterList() {
      const params = {
        projectId: this.projectId,
      };
      const { data } = await this.$api.getProjectCenterList(params);
      if (data && data.length) {
        this.projectCenterList = data.map((item) => {
          return {
            name: item.provinceName,
            enName:item.provinceNameEn,
            value: item.patientNumber,
          };
        });
      }
    },
    async getCenterPatientSize() {
      const params = {
        projectId: this.projectId,
      };
      const { data } = await this.$api.getCenterPatientSize(params);
      if(data) {
        this.centerProgress = data;
      }
    },
    async getCaseStatistics() {
      const request = {
        projectId: this.projectId,
        startDate: this.startDate,
        endDate: this.endDate,
        type: this.type,
      };
      const { data } = await this.$api.getCaseStatistics(request);
      if (data) {
        this.lineChartData = data;
      }
    },
    queryCaseType(num) {
      this.actived = num;
      this.type = num;
      this.getCaseStatistics();
    },
    queryDate(num) {
      this.activedDate = num;
      this.getDate(num);
      this.getCaseStatistics();
    },
    selectedDate(val) {
      this.activedDate = -1;
      this.startDate = val[0];
      this.endDate = val[1];
      this.getCaseStatistics();
    },
    getDate(num) {
      let date = new Date();
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let strDate = date.getDate();
      if (month < 10) {
        month = "0" + month;
      }
      if (strDate < 10) {
        strDate = "0" + strDate;
      }
      if (num) {
        this.startDate = year - num + "-" + month + "-" + strDate;
        this.endDate = year + "-" + month + "-" + strDate;
      } else {
        let time = new Date();
        time.setMonth(time.getMonth() - 6);
        let dateList = time.toLocaleDateString().split("/");
        if (dateList[1] < 10) {
          dateList[1] = "0" + dateList[1];
        }
        if (dateList[2] < 10) {
          dateList[2] = "0" + dateList[2];
        }
        this.startDate = dateList.join("-");
        this.endDate = year + "-" + month + "-" + strDate;
      }
    },
    strConvert(val) {
      if(val) {
         return Number(val.substr(0, val.length-1))
      }
    }
  },
};
</script>
<style scoped>
.wrap-shadow {
  background: #FFFFFF;
  box-shadow: 0 2px 20px 0 rgba(231,231,231,0.50);
  border-radius: 4px;
}
.container {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #f3f8fe;
}
.el-header {
  background: #fff;
  box-shadow: 0 1px 14px 0 rgba(231,231,231,0.50);
  padding: 0 23px 0 18px !important;
}
.el-main {
  height: calc(100vh - 127px);
  padding: 12px 16px;
  overflow: inherit;
  display: flex;
}
.main-center{
  flex: 1;
  overflow: hidden;
  height: 100%;
}
.group {
  display: flex;
  height: 52%;
}

.dialog-image {
  width: 100%;
}
.total-progress {
  width: 100%;
  display: flex;
  align-items: center;
  height: 58px;
  padding: 18px 25px;
  margin-bottom: 8px;
  box-sizing: border-box;
  background: #FFFFFF;
  border-bottom: 1px solid #efefef;
  box-shadow: 0 1px 14px 0 rgba(231,231,231,0.50);
  border-radius: 4px;
}
.total-title {
  font-weight: 600;
  font-size: 16px;
  color: #373C48;
  margin: 0;
}
.total-text {
  font-size: 20px;
  color:#333333;
  margin-left: 12px;
  font-weight: 700;
}
.total-percent{
  color: #1890ff;
  margin-right:25px;
}
</style>